import React, { memo, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

import { selectCurrentTest } from '../../../../../../routing/fetchingfunction/user/user.reducer'

import { millisToMinutesAndSeconds } from '../../../../../../helpers'

const QuestionaryTimer = ({ onCancelTest }) => {
  const currentTest = useSelector(selectCurrentTest)
  const [hours, minutes, seconds] = currentTest.total_test_time.split(':').map(Number)

  const [time, setTime] = useState(minutes * 60000)
  const criticalTime = 1000 * 60 * 5

  useEffect(() => {
    setTime(minutes * 60000)
  }, [currentTest])

  useEffect(() => {
    const interval = setInterval(() => {
      setTime((prevState) => {
        if (prevState <= 0) {
          clearInterval(interval)
          return prevState
        }

        return prevState - 1000
      })
    }, 1000)

    return () => {
      clearInterval(interval)
    }
  }, [])

  useEffect(() => {
    if (time < 1000) {
      onCancelTest()
    }
  }, [time])

  return (
    <div className="flex items-center justify-center min-w-[164px] shadow-button bg-[#FDFDFD] rounded-[4px] h-[32px]">
      <span className="text-base text-primary-100 font-normal mr-[8px]">Time Left</span>

      <span
        className={`inline-block text-base font-semibold text-primary-100 min-w-[48px] text-center ${time < criticalTime && 'animate-blink'}`}
      >
        {millisToMinutesAndSeconds(time)}
      </span>
    </div>
  )
}

export default memo(QuestionaryTimer)
